<template>
    <ul class="multi-select__list">
        <li v-for="option in select.options"
            :key="option.id"
            class="multi-select__item"
            :class="{'is-checked': option.value === select.value}"
            @click.self="change(option.value)">
            <div class="checkbox checkbox_size_small checkbox_theme_dark">
                <input type="radio"
                       :name="select.name"
                       :id="`${select.name}-${option.id}-${view}`"
                       :value="option.value"
                       :disabled="option.disabled"
                       class="checkbox__input"
                       v-model="select.value"
                       @change="changeRadio(select.value)">
                <label :for="`${select.name}-${option.id}-${view}`" class="checkbox__label">
                    <span class="checkbox__icon">
                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 3.54545L5.66667 8L13 1"/>
                        </svg>
                    </span>
                    <span class="checkbox__text">{{ option.text }}</span>
                </label>
            </div>
            <ul v-if="option.options" class="multi-select__item-sublist">
                <li v-for="suboption in option.options"
                    :key="suboption.id"
                    class="multi-select__subitem">
                    <div class="checkbox checkbox_size_small checkbox_type_reverse checkbox_theme_dark">
                        <input type="checkbox"
                               :name="suboption.name"
                               :id="`${option.name}-${suboption.id}-${view}`"
                               :value="suboption.value"
                               :disabled="suboption.disabled"
                               class="checkbox__input"
                               v-model="suboption.selected"
                               @change="changeSubOption(option)">
                        <label :for="`${option.name}-${suboption.id}-${view}`" class="checkbox__label">
                            <span class="checkbox__text">{{ suboption.text }}</span>
                            <span class="checkbox__icon">
                                <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 3L4.5 6.5L10 1"></path>
                                </svg>
                            </span>
                        </label>
                    </div>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
export default {
    props: ['select', 'view'],

    methods: {
        change(currentValue) {
            this.select.value = currentValue;
            this.changeRadio(currentValue);
        },

        changeRadio(currentValue) {
            // Снимает чекнутые подопции
            this.select.options.forEach((option) => {
                if (option.value !== currentValue && option.options) {
                    option.options.forEach((subOption) => {
                        subOption.selected = false;
                    });
                }
            });

            this.$emit('changeFilter');
        },

        changeSubOption(option) {
            // Чекает радио-родителя
            this.select.value = option.value;

            this.$emit('changeFilter');
        }
    }
};
</script>
